import getDifferenceInDays from 'utils/getDifferenceInDays';
import { IPlanData } from 'storage/agreements/agreements.model';

const getInstallmentsDays = (planData: IPlanData[]) =>
  planData.map(({ date }) => getDifferenceInDays(date));

export default getInstallmentsDays;
